import { CommonModule } from '@angular/common';
import { TechChartChartService } from 'ChartApp/ts/services/tech-chart-chart-service';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { ColorPickerModule } from 'NewAngular/features/components/inputs/color-picker/color-picker.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { PromptModalModule } from 'NewAngular/features/components/modals/prompt-modal/prompt-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class TechChartModule {
}
TechChartModule.ɵfac = function TechChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TechChartModule)(); };
TechChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TechChartModule });
TechChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [TechChartChartService], imports: [CommonModule,
        ColorPickerModule,
        FeatureNeededModule,
        IconModule,
        LoadingSymbolModule,
        SimpleDropdownModule,
        PromptModalModule,
        TooltipModule] });
